import { ETAB_ROUTES } from "@etab/config";
import {
  ACTION_PROFILE_INIT,
  ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED,
  ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED,
  ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED,
  ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS,
  ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS,
} from "@etab/stores/types";
import { ACTION_TRANSITIONS_SET } from "@core/store/types";
import { useProfileStore } from "@etab/stores/profile";
import { useRecruitmentCandidatesFiltersStore } from "@etab/stores/recruitment-candidates-filters";
import { useCssTransitionsStore } from "@core/store/modules/cssTransitions";
import { TRANSITIONS } from "@core/constants";
import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { useRecruitmentCandidatesStore } from "@etab/stores/recruitment-candidates";

import PermanentDetailRoot from "./PermanentDetail.root.vue";
import AppliedPage from "./Applied.page.vue";
import ContactedPage from "./Contacted.page.vue";
import IgnoredPage from "./Ignored.page.vue";
import LockedPage from "./Locked.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.recruitment.permanent.detail.root.path,
      name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.root.name,
      component: PermanentDetailRoot,
      children: [
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.detail.applied.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.applied.name,
          async beforeEnter(to, from, next) {
            const profileStore = useProfileStore();
            const cssTransitionsStore = useCssTransitionsStore();
            const recruitmentCandidatesFiltersStore = useRecruitmentCandidatesFiltersStore();
            const recruitmentCandidatesStore = useRecruitmentCandidatesStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;

              cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.RIGHT);
              await Promise.all([
                profileStore[ACTION_PROFILE_INIT](),
                recruitmentCandidatesFiltersStore[ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_LANGUAGE_OPTIONS](),
                recruitmentCandidatesFiltersStore[ACTION_RECRUITMENT_CANDIDATES_FILTERS_GET_EXPERIENCE_OPTIONS](),
                recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_APPLIED]({
                  demandId,
                  type: demandType,
                  query: to.query,
                }),
              ]);
              next();
            } catch (error) {
              NotificationsManager.error();
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
          component: AppliedPage,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.detail.contacted.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.contacted.name,
          async beforeEnter(to, from, next) {
            const cssTransitionsStore = useCssTransitionsStore();
            const recruitmentCandidatesStore = useRecruitmentCandidatesStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;

              cssTransitionsStore[ACTION_TRANSITIONS_SET](TRANSITIONS.SLIDE.LEFT);
              await recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_CONTACTED]({
                demandId,
                type: demandType,
              });
              next();
            } catch (error) {
              NotificationsManager.error();
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
          component: ContactedPage,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.detail.ignored.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.ignored.name,
          async beforeEnter(to, from, next) {
            const recruitmentCandidatesStore = useRecruitmentCandidatesStore();
            try {
              LoadingManager.show();
              const demandId = to.params.demandId;
              const demandType = to.params.demandType;

              await recruitmentCandidatesStore[ACTION_RECRUITMENT_CANDIDATES_GET_IGNORED]({
                demandId,
                type: demandType,
              });
              next();
            } catch (error) {
              NotificationsManager.error();
              throw error;
            } finally {
              LoadingManager.hide();
            }
          },
          component: IgnoredPage,
        },
        {
          path: ETAB_ROUTES.dashboard.recruitment.permanent.detail.locked.path,
          name: ETAB_ROUTES.dashboard.recruitment.permanent.detail.locked.name,
          component: LockedPage,
        },
      ],
    },
  ];
}
